var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMobilemenuicon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.6672 9.64899V4.93565C25.6672 3.08065 24.9205 2.33398 23.0655 2.33398H18.3522C16.4972 2.33398 15.7505 3.08065 15.7505 4.93565V9.64899C15.7505 11.504 16.4972 12.2507 18.3522 12.2507H23.0655C24.9205 12.2507 25.6672 11.504 25.6672 9.64899Z",
    stroke: "#202020",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2504 9.94065V4.64398C12.2504 2.99898 11.5037 2.33398 9.64874 2.33398H4.93541C3.08041 2.33398 2.33374 2.99898 2.33374 4.64398V9.92898C2.33374 11.5857 3.08041 12.239 4.93541 12.239H9.64874C11.5037 12.2507 12.2504 11.5857 12.2504 9.94065Z",
    stroke: "#202020",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2504 23.065V18.3517C12.2504 16.4967 11.5037 15.75 9.64874 15.75H4.93541C3.08041 15.75 2.33374 16.4967 2.33374 18.3517V23.065C2.33374 24.92 3.08041 25.6667 4.93541 25.6667H9.64874C11.5037 25.6667 12.2504 24.92 12.2504 23.065Z",
    stroke: "#202020",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5005 18.084H24.5005",
    stroke: "#202020",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5005 22.75H24.5005",
    stroke: "#202020",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobilemenuicon);
export default __webpack_public_path__ + "static/media/mobilemenuicon.b5601c539f7fe3a0e723ca0193cb7079.svg";
export { ForwardRef as ReactComponent };